import { render, staticRenderFns } from "./GhostButton.vue?vue&type=template&id=16379a97&scoped=true&"
import script from "./GhostButton.vue?vue&type=script&lang=js&"
export * from "./GhostButton.vue?vue&type=script&lang=js&"
import style0 from "./GhostButton.vue?vue&type=style&index=0&id=16379a97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16379a97",
  null
  
)

export default component.exports